import React, { useState } from 'react';
import { FaFacebook, FaInstagram, FaPinterest, FaCcVisa, FaCcMastercard, FaCcAmex, FaCcPaypal } from 'react-icons/fa';
import { FaThreads, FaXTwitter, FaYoutube } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

const Footer = ({ planters, container, accessoriesCat, loading }) => {
  const [newsletterEmail, setNewsletterEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (!newsletterEmail.trim()) return;
    toast.success("Thanks for subscribing! We'll be in touch.");
    setNewsletterEmail('');
  };

  const links = [
    { labelCompany: 'About Us', pathCompany: '/about-us', labelService: 'Contact Us', pathService: '/contact-us' },
    { labelService: 'Track Order', pathService: '/myaccount/orders' },
    { labelCompany: 'Terms & Conditions', pathCompany: '/terms-and-conditions', labelService: 'Return Order', pathService: '/myaccount/orders' },
    { labelCompany: 'Privacy Policy', pathCompany: '/privacy-policy', labelService: 'Cancel Order', pathService: '/myaccount/orders' },
    { labelCompany: 'Return/Refund Policy', pathCompany: '/return-policy' }
  ];


  return (
    <footer className="bg-surface-dark py-5 text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 py-10 max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Company Section */}
        <div className=''>
          <h5 className="text-white font-bold mb-3 text-base uppercase">Company</h5>
          <ul className='flex flex-wrap gap-2 md:block'>
            {links.map((item, index) => (
              <li key={index} className="mb-2">
                <Link to={item.pathCompany} className="text-xs border-r-2 md:border-none pr-1 md:pr-0 hover:text-gray-400 font-medium">
                  {item.labelCompany}
                </Link>
              </li>
            ))}
          </ul>

        </div>

        {/* Customer Service Section */}

        <div>
          <h5 className="text-white font-bold mb-3 text-base uppercase">Customer Service</h5>
          <ul className='flex flex-wrap gap-2 md:block'>
            {links.map(
              (item, index) => (
                item.labelService && (
                  <li key={index} className="mb-2">
                    <Link to={item.pathService} className="text-xs border-r-2 md:border-none pr-1 md:pr-0 hover:text-gray-400 font-medium">
                      {item.labelService}
                    </Link>
                  </li>
                )
                
              )
            )}
          </ul>
        </div>


        {/* Social Media Section */}
        <div className='ml-0 md:ml-[-25px]'>
          <h5 className="text-white font-bold mb-3 text-base uppercase">Connect With Us</h5>
          <ul className="flex space-x-6 items-center">
            <li className="flex items-center space-x-2">
              <Link
                to={"https://www.facebook.com/"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-gray-400"
              >
                <FaFacebook size={24} />
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <Link
                to={"https://www.instagram.com/"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-gray-400"
              >
                <FaInstagram size={24} />
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <Link
                to={"https://twitter.com/"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-gray-400"
              >
                <FaXTwitter size={24} />
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <Link
                to={"https://www.threads.net/"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-gray-400"
              >
                <FaThreads size={24} />
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <Link className="text-sm hover:text-gray-400" rel="noopener noreferrer" target="_blank" to={'https://in.pinterest.com/'}>
                <FaPinterest size={24} />
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <Link className="text-sm hover:text-gray-400" rel="noopener noreferrer" target="_blank" to={'https://youtube.com/'}>
                <FaYoutube size={24} />
              </Link>
            </li>
          </ul>
        </div>

        {/* Newsletter Section */}
        <div>
          <h5 className="text-white font-bold mb-3 text-base uppercase">Newsletter</h5>
          <p className="text-xs text-gray-400 mb-3">
            Subscribe to get special offers, free giveaways, and once-in-a-lifetime deals.
          </p>
          <form className='w-full flex' onSubmit={handleNewsletterSubmit}>
            <input
              type="email"
              required
              value={newsletterEmail}
              onChange={(e) => setNewsletterEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 min-w-0 p-2 text-sm bg-gray-900 text-white
              focus:outline-none border-b-2 border-brand-600"
            />
            <button type="submit" className="bg-brand-600 hover:bg-brand-700 text-white p-2 font-semibold text-sm transition-colors">
              SUBSCRIBE
            </button>
          </form>
        </div>
      </div>

      <div className="footer_down max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* <hr />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-10">
          <div>
            <h5 className="font-bold mb-3 text-base uppercase">Planters</h5>
            {loading ? (
              <ul>
                {Array.from({ length: 7 }).map((_, index) => (
                  <li key={index}>
                    <Skeleton height={15} width={"100%"} />
                  </li>
                ))}
              </ul>
            ) : (
              <ul className='flex flex-wrap gap-2 md:block'>
                {Array.isArray(planters) &&
                  planters.map((item) => (
                    <li key={item.id} className="mb-2">
                      <Link to={`../${item.slug}`} className="text-xs border-r-2 md:border-none pr-1 md:pr-0 hover:text-gray-400 font-medium">
                        {item.category_name}
                      </Link>
                    </li>
                  ))}
              </ul>
            )}

          </div>

          <div>
            <h5 className="font-bold mb-3 text-base uppercase">Container</h5>
            {loading?(
              <ul>
              {Array.from({ length: 7 }).map((_, index) => (
                <li key={index}>
                  <Skeleton height={15} width={"100%"} />
                </li>
              ))}
            </ul>
            ):(
              <ul className='flex flex-wrap gap-2 md:block'>
                {Array.isArray(container) &&
                  container.map((item) => (
                    <li key={item.id} className="mb-2">
                      <Link to={`../${item.slug}`} className="text-xs border-r-2 md:border-none pr-1 hover:text-gray-400 font-medium">
                        {item.category_name}
                      </Link>
                    </li>
                  ))}
              </ul>
            )}
          </div>

        </div> */}

       
        <hr className='my-3 border-white/10' />

        <div className='flex-col flex justify-center gap-2 md:gap-0 text-sm md:justify-between items-center md:flex-row'>
          <div>
            Copyright © {new Date().getFullYear()} <span className='text-brand-500'>MPI Virgin Plastic</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-gray-400">Secure Payments</span>
            <div className="flex items-center gap-2 text-2xl text-gray-300">
              <FaCcVisa />
              <FaCcMastercard />
              <FaCcAmex />
              <FaCcPaypal />
            </div>
          </div>
          <div>
            Designed & developed by <Link className='text-brand-500' target='_blank' to='https://kyleinfotech.co.in/'>Kyle Infotech</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
